(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function range(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }

  function init(root) {
    if (!root || root.dataset.vxeInit) return;
    root.dataset.vxeInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { root.classList.add('is-static'); return; }

    var track = root.querySelector('.vxe__track');
    var media = root.querySelector('[data-vxe-media]');
    var img = root.querySelector('.vxe__img, .vxe__ph');
    var shade = root.querySelector('[data-vxe-shade]');
    var fin = root.querySelector('[data-vxe-final]');
    var l1 = root.querySelector('[data-vxe-l1]');
    var l2 = root.querySelector('[data-vxe-l2]');
    var head = root.querySelector('[data-vxe-head]');
    var hint = root.querySelector('[data-vxe-hint]');
    var ticking = false;

    function startInset() {
      var mobile = window.innerWidth <= 760;
      return mobile ? { t: 26, b: 25, x: 14, r: 20 } : { t: 28, b: 30, x: 36, r: 24 };
    }

    function render() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var total = track.offsetHeight - window.innerHeight;
      var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 1;

      var s = startInset();
      var e = ease(range(p, 0, .72));             // розширення фото
      var k = 1 - e;
      media.style.clipPath = 'inset(' + (s.t * k) + '% ' + (s.x * k) + '% ' + (s.b * k) + '% ' + (s.x * k) + '% round ' + (s.r * k) + 'px)';
      if (img) img.style.transform = 'scale(' + (1.18 - .18 * e) + ')';

      var split = ease(range(p, 0, .55));          // рядки розʼїжджаються
      var shift = split * 60;
      if (l1) { l1.style.transform = 'translateX(' + (-shift) + 'vw)'; l1.style.opacity = String(1 - split); }
      if (l2) { l2.style.transform = 'translateX(' + shift + 'vw)'; l2.style.opacity = String(1 - split); }
      var fade = 1 - range(p, 0, .2);
      if (head) head.style.opacity = String(fade);
      if (hint) hint.style.opacity = String(.75 * fade);

      var f = ease(range(p, .7, .95));             // фінальна фраза
      if (shade) shade.style.opacity = String(f);
      if (fin) { fin.style.opacity = String(f); fin.style.transform = 'translate(-50%, ' + (30 * (1 - f)) + 'px)'; }
    }

    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-expand]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-about-text-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function norm(w) { return w.toLowerCase().replace(/[.,!?;:—–"„”«»()]/g, ''); }

  function init(root) {
    if (!root || root.dataset.vtrInit) return;
    root.dataset.vtrInit = '1';

    var textEl = root.querySelector('[data-vtr-text]');
    var sign = root.querySelector('[data-vtr-sign]');
    var bar = root.querySelector('[data-vtr-bar]');
    var track = root.querySelector('.vtr__track');
    if (!textEl) return;

    // Розбити на слова
    var raw = textEl.textContent.trim().split(/\s+/);
    var hlWords = (root.getAttribute('data-highlight') || '').trim().split(/\s+/).filter(Boolean).map(norm);
    textEl.textContent = '';
    textEl.setAttribute('aria-label', raw.join(' '));
    var words = [];
    raw.forEach(function (w, i) {
      var sp = document.createElement('span'); sp.className = 'vtr__w'; sp.textContent = w; sp.setAttribute('aria-hidden', 'true');
      textEl.appendChild(sp); if (i < raw.length - 1) textEl.appendChild(document.createTextNode(' '));
      words.push(sp);
    });
    // Підсвітити послідовність слів із поля "Wyróżnienie"
    if (hlWords.length) {
      for (var i = 0; i <= words.length - hlWords.length; i++) {
        var ok = true;
        for (var j = 0; j < hlWords.length; j++) { if (norm(words[i + j].textContent) !== hlWords[j]) { ok = false; break; } }
        if (ok) { for (var k = 0; k < hlWords.length; k++) words[i + k].classList.add('is-hl'); break; }
      }
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = window.Shopify && window.Shopify.designMode;
    if (reduce || editor) {
      root.classList.add('is-static');
      words.forEach(function (w) { w.classList.add('is-on'); });
      if (sign) sign.classList.add('is-on');
      return;
    }

    var ticking = false;
    function render() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var total = track.offsetHeight - window.innerHeight;
      var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 1;
      var lit = Math.round(clamp(p / 0.85, 0, 1) * words.length);
      for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-on', i < lit);
      if (sign) sign.classList.toggle('is-on', p > 0.88);
      if (bar) bar.style.transform = 'scaleX(' + p + ')';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-text-reveal]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-certyfikat"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MONTHS = ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia'];
  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }

  function initCert(root) {
    if (!root || root.dataset.vgcInit) return;
    root.dataset.vgcInit = 'true';

    var input = root.querySelector('[data-vgc-input]');
    var select = root.querySelector('[data-vgc-select]');
    var nameEl = root.querySelector('[data-vgc-name]');
    var countEl = root.querySelector('[data-vgc-count]');
    var dateEl = root.querySelector('[data-vgc-date]');
    var validEl = root.querySelector('[data-vgc-valid]');

    var namePlaceholder = nameEl ? nameEl.textContent : '';

    // Дати: сьогодні + 3 місяці (прев'ю)
    var today = new Date();
    var valid = new Date(); valid.setMonth(valid.getMonth() + 3);
    if (dateEl) dateEl.textContent = fmt(today);
    if (validEl) validEl.textContent = fmt(valid);

    function setCount() {
      if (!countEl || !select) return;
      var opt = select.options[select.selectedIndex];
      var c = opt ? opt.value : '';
      countEl.textContent = c ? (c + ' zajęć') : '—';
    }
    setCount();

    if (input && nameEl) {
      input.addEventListener('input', function () {
        var v = input.value.trim();
        nameEl.textContent = v.length ? v : namePlaceholder;
      });
    }
    if (select) select.addEventListener('change', setCount);

    root.querySelectorAll('[data-vgc-tier]').forEach(function (tier) {
      tier.addEventListener('click', function () {
        if (!select) return;
        var c = tier.getAttribute('data-count');
        if (c == null || c === '') return;
        select.value = String(c);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var variantsEl = root.querySelector('[data-vgc-variants]');
    var cfgEl = root.querySelector('[data-vgc-buy-cfg]');
    var cta = root.querySelector('[data-vgc-buy]');
    var variants = [];
    var cfg = {};
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (err) { variants = []; }
    try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (err) { cfg = {}; }

    if (cta && variants && variants.length) {
      var errNameEl = root.querySelector('[data-vgc-err-name]');
      var errCartEl = root.querySelector('[data-vgc-err-cart]');
      var nameBox = input ? input.closest('.vgc-namebox') : null;
      var ctaT = cta.querySelector('[data-vgc-cta-t]') || cta;
      var ctaDefault = ctaT.textContent;

      function showNameErr() {
        if (errNameEl) { errNameEl.hidden = false; errNameEl.textContent = cfg.errName || ''; }
        if (nameBox) { nameBox.classList.remove('is-bad'); void nameBox.offsetWidth; nameBox.classList.add('is-bad'); }
        if (input) input.focus();
      }
      function clearNameErr() {
        if (errNameEl) errNameEl.hidden = true;
        if (nameBox) nameBox.classList.remove('is-bad');
      }
      function showCartErr() {
        if (errCartEl) { errCartEl.hidden = false; errCartEl.textContent = cfg.errCart || ''; }
      }
      if (input) input.addEventListener('input', function () { if (input.value.trim()) clearNameErr(); });

      function findVariant(count) {
        var n = String(count || '');
        var i, v;
        for (i = 0; i < variants.length; i++) {
          v = variants[i];
          if (v && String(v.title).indexOf(n) !== -1) return v;
        }
        if (n === '8' && variants[1]) return variants[1];
        return variants[0] || null;
      }

      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (cta.getAttribute('aria-disabled') === 'true') return;
        var name = input ? input.value.trim() : '';
        if (!name) { showNameErr(); return; }
        var variant = findVariant(select ? select.value : '4');
        if (!variant || !variant.id) { showCartErr(); return; }
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var props = {};
        props[cfg.propName || 'Imię osoby obdarowanej'] = name;
        cta.setAttribute('aria-disabled', 'true');
        ctaT.textContent = cfg.labelSending || '';
        if (errCartEl) errCartEl.hidden = true;
        fetch(rootUrl + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            return fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: +variant.id, quantity: 1, properties: props }] })
            });
          })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () { window.location.href = rootUrl + 'checkout'; })
          .catch(function () {
            cta.removeAttribute('aria-disabled');
            ctaT.textContent = ctaDefault;
            showCartErr();
          });
      });
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-cert]').forEach(initCert); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-grafik"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(box) {
    if (!box || box.dataset.vgInit) return;
    box.dataset.vgInit = '1';
    var form = box.querySelector('[data-vg-form]');
    if (!form) return;
    var cfgEl = box.querySelector('[data-vg-cfg]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var child = form.querySelector('input[name="child"]');
    var err = box.querySelector('[data-vg-err]');
    var btn = box.querySelector('[data-vg-submit]');
    var btnT = box.querySelector('[data-vg-submit-t]');
    var radios = box.querySelectorAll('.vg-price__input');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = window.Shopify && window.Shopify.designMode;

    function selectedInput() {
      return box.querySelector('.vg-price__input:checked');
    }
    function selected() {
      var on = box.querySelector('.vg-price--pick.is-on');
      if (on) return on;
      var inp = selectedInput();
      return inp ? inp.closest('.vg-price--pick') : null;
    }
    function showErr(msg, target) {
      if (err) { err.hidden = false; err.textContent = msg || ''; }
      var shakeEl = target || form;
      shakeEl.classList.remove('is-shake');
      void shakeEl.offsetWidth;
      if (!reduce) shakeEl.classList.add('is-shake');
      if (target && target.classList) target.classList.add('is-err');
      if (shakeEl.scrollIntoView) shakeEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    function clearErr() {
      if (err) { err.hidden = true; err.textContent = ''; }
      if (child) child.classList.remove('is-err');
      form.classList.remove('is-shake');
      if (child) child.classList.remove('is-shake');
    }
    function syncBtn() {
      var row = selected();
      if (!cfg.hasProduct) {
        if (btnT) btnT.textContent = cfg.preview || 'Zakup online wkrótce';
        return;
      }
      var money = row ? row.getAttribute('data-money') : '';
      if (btnT) btnT.textContent = money ? (cfg.submit + ' · ' + money) : (cfg.submit || '');
    }
    function markRows() {
      box.querySelectorAll('.vg-price--pick').forEach(function (row) {
        var on = row.querySelector('.vg-price__input:checked');
        row.classList.toggle('is-on', !!on);
      });
      syncBtn();
      clearErr();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', markRows);
    });
    box.querySelectorAll('.vg-price--pick').forEach(function (row) {
      row.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('input')) return;
        var inp = row.querySelector('.vg-price__input');
        if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    if (child) child.addEventListener('input', clearErr);
    syncBtn();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErr();
      if (editor) return;
      if (!cfg.hasProduct) { showErr(cfg.preview, form); return; }
      var inp = selectedInput();
      var row = selected();
      if (!inp || !row) { showErr(cfg.errChoose, box.querySelector('.vg-price-list')); return; }
      var name = child ? child.value.trim() : '';
      if (!name) {
        showErr(cfg.errChild, child);
        if (child) { child.classList.add('is-err'); child.focus(); }
        return;
      }
      var id = parseInt(inp.value, 10);
      if (!id) { showErr(cfg.errCart, form); return; }
      btn.classList.add('is-busy');
      if (btnT) btnT.textContent = cfg.sending || '';
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var payload = {
        items: [{
          id: id,
          quantity: 1,
          properties: {
            'Dziecko': name,
            'Grupa': row.getAttribute('data-label') || ''
          }
        }]
      };
      var pre = cfg.clear ? fetch(rootUrl + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }) : Promise.resolve();
      pre.then(function () {
        return fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () { window.location.href = rootUrl + 'checkout'; })
        .catch(function () {
          btn.classList.remove('is-busy');
          syncBtn();
          showErr(cfg.errCart, form);
        });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-vg-buy]').forEach(init);
  }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-hero-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var ex = document.querySelector('script[src="' + src + '"]');
      if (ex) { resolve(); return; }
      var s = document.createElement('script'); s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function ensureLibs() {
    return Promise.resolve()
      .then(function () { return window.gsap || loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js'); })
      .then(function () { return window.CustomEase || loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/CustomEase.min.js'); })
      .then(function () { return window.SplitType || loadScript('https://cdn.jsdelivr.net/npm/split-type@0.3.4/umd/index.min.js'); });
  }

  function splitHeadline(root) {
    var h2 = root.querySelector('.vhi-h2');
    if (!h2 || !window.SplitType || h2.dataset.split) return;
    h2.dataset.split = '1';
    var split = new SplitType(h2, { types: 'lines' });
    split.lines.forEach(function (line) {
      var wrapper = document.createElement('div'); wrapper.className = 'line';
      var span = document.createElement('span'); span.textContent = line.textContent;
      wrapper.appendChild(span); line.parentNode.replaceChild(wrapper, line);
    });
  }
  function splitBrand(root) {
    var wrap = root.querySelector('[data-vhi-brand]');
    if (!wrap || wrap.dataset.split === '1') return;
    wrap.querySelectorAll('.vhi-brand__word').forEach(function (word) {
      var text = word.textContent;
      word.textContent = '';
      for (var i = 0; i < text.length; i++) {
        var s = document.createElement('span');
        s.className = 'vhi-ch';
        s.textContent = text.charAt(i);
        word.appendChild(s);
      }
    });
    wrap.dataset.split = '1';
  }
  function showBrand(root) {
    root.querySelectorAll('.vhi-brand .vhi-ch').forEach(function (t) {
      t.style.opacity = '1';
      t.style.transform = 'none';
    });
    var ribbon = root.querySelector('.vhi-brand__ribbon');
    if (ribbon) ribbon.classList.add('is-draw');
    var path = root.querySelector('.vhi-brand__ribbon path');
    if (path) { path.style.strokeDashoffset = '0'; path.style.opacity = '1'; }
    var tagWrap = root.querySelector('.vhi-tagline-wrap');
    if (tagWrap) { tagWrap.style.clipPath = 'none'; tagWrap.style.overflow = 'visible'; }
  }
  function reveals(root) { return root.querySelectorAll('.vhi-rv, .vhi-h2 .line span'); }

  function finish(root) {
    if (root.dataset.vhiDone) return;
    root.dataset.vhiDone = '1';
    var pl = buildPile(root);
    if (pl) {
      var pc = pl.querySelectorAll('.vhi-pile__c');
      if (window.gsap) gsap.to(pc, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out' });
      else pc.forEach(function (c) { c.style.opacity = 1; c.style.visibility = 'visible'; });
      watchPile(root);
    }
    var intro = root.querySelector('.vhi-intro'); if (intro) intro.remove();
    var hero = root.querySelector('.vhi-hero'); if (hero) hero.style.opacity = '1';
    splitBrand(root);
    showBrand(root);
    reveals(root).forEach(function (t) { t.style.transform = 'translateY(0)'; });
    var photo = root.querySelector('.vhi-photo');
    if (photo) { photo.style.clipPath = 'inset(0 0 0 0 round 16px)'; photo.style.opacity = '1'; photo.style.transform = 'none'; photo.style.filter = 'none'; }
    root.classList.add('is-done', 'is-live');
  }

  function shouldPlay(root) {
    var mode = root.getAttribute('data-play-mode') || 'always';
    if (mode === 'always') return true;
    var seen = false;
    try { seen = sessionStorage.getItem('vivaIntroSeen') === '1'; } catch (e) {}
    if (mode === 'session') return !seen;
    // entry_reload: грає при першому вході та при оновленні; не грає при переході всередині сайту
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (nav.type === 'reload') return true;
    var internal = false;
    try { internal = document.referrer && new URL(document.referrer).host === location.host; } catch (e) {}
    return !(internal && seen);
  }

  // ===== Stos 3 zdjęć w lewym dolnym rogu hero =====
  var PILE_DESK = window.matchMedia('(min-width: 1200px)');
  function pileRot(k) { return PILE_DESK.matches ? ([-3, 2, -2][k] || 0) : 0; }
  function buildPile(root) {
    var ex = root.querySelector('.vhi-pile');
    if (ex) return ex;
    var srcs = Array.prototype.slice.call(root.querySelectorAll('.vhi-img')).slice(-3).reverse();
    if (!srcs.length) return null;
    var pile = document.createElement('div');
    pile.setAttribute('aria-hidden', 'true');
    srcs.forEach(function (el) {
      var im = el.tagName === 'IMG' ? el : el.querySelector('img');
      var c = document.createElement('div');
      c.className = 'vhi-pile__c';
      if (im) { var ni = new Image(); ni.src = im.currentSrc || im.src; ni.alt = ''; ni.decoding = 'async'; if (ni.decode) ni.decode().catch(function () {}); c.appendChild(ni); }
      else { c.style.backgroundImage = getComputedStyle(el).backgroundImage; }
      pile.appendChild(c);
    });
    var photo = root.querySelector('.vhi-photo');
    if (PILE_DESK.matches || !photo) {
      // komputer: kolumna z lewej (1 na dole, 3 na górze)
      pile.className = 'vhi-pile vhi-pile--col';
      if (getComputedStyle(root).position === 'static') root.style.position = 'relative';
      root.appendChild(pile);
    } else {
      // telefon/tablet: równy rząd 3 kart pod zdjęciem hero, w normalnym przepływie
      pile.className = 'vhi-pile vhi-pile--row';
      photo.parentNode.insertBefore(pile, photo.nextSibling);
    }
    var cs = pile.querySelectorAll('.vhi-pile__c');
    if (window.gsap) cs.forEach(function (c, k) { gsap.set(c, { rotation: pileRot(k), autoAlpha: 0 }); });
    return pile;
  }
  function watchPile(root) {
    var pile = root.querySelector('.vhi-pile');
    if (!pile || pile.dataset.watch) return;
    pile.dataset.watch = '1';
    var g = window.gsap, cards = pile.querySelectorAll('.vhi-pile__c');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!g || !('IntersectionObserver' in window)) { cards.forEach(function (c) { c.style.opacity = 1; c.style.visibility = 'visible'; }); return; }
    var shown = parseFloat(getComputedStyle(cards[0]).opacity) > 0.5;
    new IntersectionObserver(function (es) {
      var vis = es[0].isIntersecting && es[0].intersectionRatio > 0.15;
      if (vis === shown) return;
      shown = vis;
      if (vis) g.fromTo(cards, { autoAlpha: 0, y: 40, scale: 0.9 }, { autoAlpha: 1, y: 0, scale: 1, duration: reduce ? 0.01 : 0.9, ease: 'power3.out', stagger: reduce ? 0 : 0.1, overwrite: true });
      else g.to(cards, { autoAlpha: 0, y: 30, scale: 0.94, duration: reduce ? 0.01 : 0.6, ease: 'power2.inOut', stagger: { each: 0.06, from: 'end' }, overwrite: true });
    }, { threshold: [0, 0.15, 0.5] }).observe(pile);
  }

  function exitStack(root, imgs, intro, g) {
    var box = root.querySelector('.vhi-images');
    if (intro) intro.style.background = 'transparent';
    if (box) box.style.background = 'transparent';
    var fly = imgs.slice(-3).reverse();                       // od górnego
    imgs.slice(0, -3).forEach(function (el) { g.set(el, { autoAlpha: 0 }); });
    fly.forEach(function (el) { g.set(el, { autoAlpha: 1 }); });
    var pile = buildPile(root);
    var cards = pile ? pile.querySelectorAll('.vhi-pile__c') : [];
    var delays = [0, 0.28, 0.6], durs = [1.1, 1.05, 1.35];
    var vh = window.innerHeight;
    fly.forEach(function (el, k) {
      var card = cards[k];
      var r = el.getBoundingClientRect();
      var cr = card ? card.getBoundingClientRect() : null;
      var inView = cr && cr.top < vh - 20 && cr.bottom > 20;
      if (!inView) {
        // telefon: miejsce kart jest niżej — zdjęcie łagodnie maleje i gaśnie, karty wyjadą przy przewinięciu
        g.to(el, { scale: 0.6, y: vh * 0.15, autoAlpha: 0, duration: durs[k], delay: delays[k], ease: 'power2.inOut', force3D: true });
        if (card) g.set(card, { autoAlpha: 0 });
        return;
      }
      g.set(card, { rotation: 0 }); cr = card.getBoundingClientRect(); g.set(card, { rotation: pileRot(k) });
      var ea = r.width / r.height, ca = cr.width / cr.height, ix = 0, iy = 0, s;
      if (ea > ca) { ix = (1 - ca / ea) / 2 * 100; s = cr.height / r.height; }
      else { iy = (1 - ea / ca) / 2 * 100; s = cr.width / r.width; }
      var rad = (14 / s).toFixed(1);
      g.set(el, { clipPath: 'inset(0% 0% 0% 0% round 0px)' });
      g.to(el, {
        x: (cr.left + cr.width / 2) - (r.left + r.width / 2),
        y: (cr.top + cr.height / 2) - (r.top + r.height / 2),
        scale: s,
        rotation: pileRot(k),
        clipPath: 'inset(' + iy.toFixed(2) + '% ' + ix.toFixed(2) + '% ' + iy.toFixed(2) + '% ' + ix.toFixed(2) + '% round ' + rad + 'px)',
        duration: durs[k], delay: delays[k], ease: 'power3.inOut', force3D: true,
        onComplete: function () {
          g.set(card, { autoAlpha: 1 });
          g.to(el, { autoAlpha: 0, duration: 0.2, ease: 'none' });
        }
      });
    });
    g.delayedCall(delays[2] + durs[2] + 0.45, function () {
      root.classList.add('is-live');
      watchPile(root);
      g.delayedCall(0.3, function () { if (intro) intro.remove(); });
    });
  }

  function buildMid(root, intro, photo) {
    var pimg = photo && photo.querySelector('img');
    if (!pimg || !intro) return null;
    var rr = root.getBoundingClientRect(), pr = photo.getBoundingClientRect(), vh = window.innerHeight;
    var ar = (pimg.naturalWidth && pimg.naturalHeight) ? pimg.naturalWidth / pimg.naturalHeight : (pr.width / pr.height || 0.75);
    var w, h, left, top;
    if (pr.width > 40 && pr.top >= rr.top && pr.bottom <= vh - 10) {
      w = pr.width; h = pr.height; left = pr.left - rr.left; top = pr.top - rr.top;   // tam, gdzie będzie zdjęcie hero
    } else {
      w = Math.min(window.innerWidth * 0.46, 300); h = w / ar;                         // telefon: po środku, jak na wideo
      left = (rr.width - w) / 2; top = Math.max(vh * 0.42 - rr.top, 0);
      if (top + h > vh - rr.top - 16) { h = vh - rr.top - 16 - top; w = h * ar; left = (rr.width - w) / 2; }
    }
    var mid = document.createElement('div');
    mid.className = 'vhi-mid';
    mid.setAttribute('aria-hidden', 'true');
    mid.style.cssText = 'left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;height:' + h + 'px;';
    var mi = new Image(); mi.src = pimg.currentSrc || pimg.src; mi.alt = ''; mi.decoding = 'async';
    mid.appendChild(mi);
    intro.appendChild(mid);
    return mid;
  }

  function play(root) {
    var g = window.gsap;
    var intro = root.querySelector('.vhi-intro'),
        imgs = Array.prototype.slice.call(root.querySelectorAll('.vhi-img')),
        hero = root.querySelector('.vhi-hero'),
        photo = root.querySelector('.vhi-photo'),
        letters = root.querySelectorAll('.vhi-brand .vhi-ch'),
        ribbonEl = root.querySelector('.vhi-brand__ribbon'),
        tagWrap = root.querySelector('.vhi-tagline-wrap');
    var HOP = 'power4.inOut', TXT = 'expo.out';
    g.set(imgs, { force3D: true });
    g.set(hero, { opacity: 1 });
    var mid = buildMid(root, intro, photo);
    var tl = g.timeline({ onComplete: function () { root.classList.add('is-done'); } });

    tl.to(root.querySelector('.vhi-r-1'), { yPercent: -100, duration: 1.4, ease: HOP }, 0)
      .to(root.querySelector('.vhi-r-2'), { yPercent: 100, duration: 1.4, ease: HOP }, 0);

    // od razu: nazwa + czarny tekst nad zdjęciami, zdjęcie drużyny po środku
    tl.addLabel('base', 0.6);
    if (mid) tl.fromTo(mid, { autoAlpha: 0, y: 30, scale: 0.96 }, { autoAlpha: 1, y: 0, scale: 1, duration: 1.2, ease: 'power3.out' }, 'base');
    if (letters.length) tl.fromTo(letters, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.6, ease: TXT, stagger: 0.03 }, 'base+=0.2');
    tl.add(function () { g.to(root.querySelectorAll('.vhi-h2 .line span, .vhi-sub'), { y: 0, duration: 1.2, ease: TXT, stagger: 0.07 }); }, 'base+=0.35');

    // zdjęcia za treścią: każde następne szybciej, ostatnie wolno
    tl.fromTo(imgs[0], { autoAlpha: 0, scale: 1.12 }, { autoAlpha: 1, scale: 1, duration: 1.8, ease: 'power2.out' }, 0.3);
    tl.addLabel('show', 2.1);
    tl.add(function () { buildPile(root); }, 'show');
    var t = 0.2, gap = 0.85;
    for (var i = 1; i < imgs.length; i++) {
      var last = i === imgs.length - 1;
      if (last) {
        t += 0.3;
        if (mid) tl.to(mid, { autoAlpha: 0, y: 20, scale: 0.96, duration: 0.6, ease: 'power2.inOut' }, 'show+=' + Math.max(0, t - 0.5).toFixed(2)); // znika przed ostatnim zdjęciem
      }
      var d = last ? 1.4 : Math.max(0.45, gap * 1.1);
      tl.fromTo(imgs[i], { autoAlpha: 0, scale: last ? 1.1 : 1.06 }, { autoAlpha: 1, scale: 1, duration: d, ease: last ? 'power2.out' : 'sine.out' }, 'show+=' + t.toFixed(2));
      if (i >= 3) tl.set(imgs[i - 3], { autoAlpha: 0 }, 'show+=' + (t + d).toFixed(2));
      if (!last) { t += gap; gap = Math.max(0.22, gap * 0.8); }
    }
    tl.to({}, { duration: 0.4 });

    tl.addLabel('exit');
    tl.add(function () { exitStack(root, imgs, intro, g); }, 'exit');

    // po zebraniu: zdjęcie drużyny już w hero, wstążka, slogan, przyciski
    tl.addLabel('heroIn', 'exit+=0.9');
    if (photo) tl.to(photo, { opacity: 1, y: 0, scale: 1, clipPath: 'inset(0% 0% 0% 0% round 16px)', duration: 1.4, ease: 'power3.out' }, 'heroIn');
    tl.add(function () { if (ribbonEl) ribbonEl.classList.add('is-draw'); }, 'heroIn+=0.1');
    if (tagWrap) tl.fromTo(tagWrap, { clipPath: 'inset(-20% 100% -30% -5%)' }, { clipPath: 'inset(-20% -5% -30% -5%)', duration: 1, ease: TXT,
      onComplete: function () { tagWrap.style.clipPath = 'none'; tagWrap.style.overflow = 'visible'; } }, 'heroIn+=0.2');
    tl.add(function () { g.to(root.querySelectorAll('.vhi-actions .vhi-rv'), { y: 0, duration: 1.2, ease: TXT, stagger: 0.1 }); }, 'heroIn+=0.4');
    tl.to({}, { duration: 1.4 });
  }

  function initIntro(root) {
    if (!root || root.dataset.vhiInit) return;
    root.dataset.vhiInit = 'true';
    var editor = window.Shopify && window.Shopify.designMode;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasImages = root.querySelectorAll('.vhi-img').length > 0;
    if (editor || reduce) root.classList.add('vhi--still');
    var safety = setTimeout(function () { finish(root); }, 10000);

    ensureLibs().then(function () {
      splitHeadline(root);
      splitBrand(root);
      if (editor || reduce || !hasImages || !window.gsap || !shouldPlay(root)) { clearTimeout(safety); finish(root); return; }
      try { sessionStorage.setItem('vivaIntroSeen', '1'); } catch (e) {}
      play(root);
      setTimeout(function () { clearTimeout(safety); }, 0);
      setTimeout(function () { if (!root.classList.contains('is-live')) finish(root); }, 25000);
    }).catch(function () { clearTimeout(safety); finish(root); });
  }

  // Кнопка "назад": браузер відновлює сторінку з памʼяті (без запуску скриптів) → перезавантажуємо, щоб інтро зіграло знову
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var root = document.querySelector('[data-viva-hero-intro]');
    if (!root || (window.Shopify && window.Shopify.designMode)) return;
    var mode = root.getAttribute('data-play-mode') || 'always';
    if (mode === 'always') location.reload();
  });

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-hero-intro]').forEach(initIntro); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-home-coach"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vhcInit) return;
    root.dataset.vhcInit = '1';
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(root);
    setTimeout(function () { root.classList.add('is-in'); }, 4000); // запобіжник
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-viva-home-coach]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-home-grafik"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vhgInit) return;
    root.dataset.vhgInit = '1';
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.15 });
    io.observe(root);
    setTimeout(function () { root.classList.add('is-in'); }, 4000);
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-viva-home-grafik]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-home-history"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vhhInit) return;
    root.dataset.vhhInit = '1';

    var stage = root.querySelector('[data-vhh-stage]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vhh-card]'));
    var dotsWrap = root.querySelector('[data-vhh-dots]');
    var pauseBtn = root.querySelector('[data-vhh-pause]');
    var n = cards.length;
    var active = 0, timer = null, userPaused = false, hover = false, dragging = false, visible = false;
    var interval = Math.max(1500, (parseFloat(root.getAttribute('data-interval')) || 2.5) * 1000);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = window.Shopify && window.Shopify.designMode;
    var floatEl = root.querySelector('.vh-float');
    var tiltEl = root.querySelector('.vh-float__tilt');
    var shineEl = root.querySelector('.vh-float__shine');
    var shadowEl = root.querySelector('.vh-float__shadow');
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (reduce || editor) root.classList.add('vhh--still');

    function setFloatPlay(on) {
      var state = on ? 'running' : 'paused';
      if (floatEl) floatEl.style.animationPlayState = state;
      if (shadowEl) shadowEl.style.animationPlayState = state;
    }

    // Поява при скролі + пауза плавання поза екраном
    if ('IntersectionObserver' in window && !editor) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) root.classList.add('is-in');
          visible = e.isIntersecting; sync();
          if (!reduce) setFloatPlay(visible);
          if (!visible && tiltEl && !finePointer) tiltEl.style.transform = 'translate3d(0,0,0)';
        });
      }, { threshold: 0.2 });
      io.observe(root);
      setFloatPlay(false);
    } else { root.classList.add('is-in'); visible = true; }
    setTimeout(function () { root.classList.add('is-in'); }, 4000);

    if (!n) return;

    // Крапки
    var dots = [];
    if (dotsWrap && n > 1) {
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Zdjęcie ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }

    function layout() {
      var wide = window.innerWidth > 860;
      var step = wide ? 20 : 16;
      cards.forEach(function (c, i) {
        var off = i - active;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        var abs = Math.abs(off);
        var tx = off * step, rot = off * 7, sc = 1 - abs * 0.09, ty = abs * 3;
        c.style.transform = 'translate(calc(-50% + ' + tx + '%), calc(-50% + ' + ty + '%)) rotate(' + rot + 'deg) scale(' + sc + ')';
        c.style.zIndex = String(100 - abs);
        c.style.opacity = abs > 2 ? '0' : '1';
        c.style.filter = abs === 0 ? 'none' : 'saturate(.75) brightness(.96)';
        c.classList.toggle('is-active', abs === 0);
        c.setAttribute('aria-hidden', abs === 0 ? 'false' : 'true');
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === active ? 'true' : 'false'); });
    }
    function go(i) { active = (i + n) % n; layout(); }
    function next() { go(active + 1); }
    function prev() { go(active - 1); }

    function sync() {
      var shouldRun = n > 1 && !userPaused && !hover && !dragging && visible && !reduce && !editor && !document.hidden;
      if (shouldRun && !timer) timer = setInterval(next, interval);
      if (!shouldRun && timer) { clearInterval(timer); timer = null; }
    }
    function restart() { if (timer) { clearInterval(timer); timer = null; } sync(); }

    var nb = root.querySelector('[data-vhh-next]'), pb = root.querySelector('[data-vhh-prev]');
    if (nb) nb.addEventListener('click', function () { next(); restart(); });
    if (pb) pb.addEventListener('click', function () { prev(); restart(); });
    if (pauseBtn) {
      if (reduce) { userPaused = true; pauseBtn.setAttribute('aria-pressed', 'true'); }
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Wznów automatyczne przewijanie' : 'Zatrzymaj automatyczne przewijanie');
        hover = false; restart();
        if (!userPaused) next();
      });
    }

    // Пауза при наведенні / фокусі
    // Пауза при наведенні — лише для справжньої мишки (на телефоні дотик не "залипає")
    stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; sync(); } });
    stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; sync(); } });
    // Пауза при фокусі з клавіатури — лише на самій галереї, не на кнопках
    stage.addEventListener('focus', function () { if (stage.matches(':focus-visible')) { hover = true; sync(); } });
    stage.addEventListener('blur', function () { hover = false; sync(); });
    document.addEventListener('visibilitychange', sync);

    // Перетягування / свайп
    var startX = null, moved = false;
    stage.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; stage.classList.add('is-dragging'); dragging = true; sync(); });
    window.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); moved = true; }
      startX = null; stage.classList.remove('is-dragging');
      dragging = false; restart();
    });
    window.addEventListener('pointercancel', function () { startX = null; dragging = false; stage.classList.remove('is-dragging'); restart(); });

    // Клавіатура
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); restart(); }
      if (e.key === 'ArrowLeft') { prev(); restart(); }
    });

    window.addEventListener('resize', layout);
    layout(); sync();

    if (!reduce && !editor && tiltEl) {
      var paraRaf = 0;
      function applyParallax() {
        paraRaf = 0;
        if (!visible || finePointer) return;
        var r = tiltEl.getBoundingClientRect();
        var mid = window.innerHeight / 2;
        var t = (r.top + r.height / 2 - mid) / Math.max(mid, 1);
        if (t > 1) t = 1; else if (t < -1) t = -1;
        tiltEl.style.transform = 'translate3d(0,' + (t * -20).toFixed(1) + 'px,0)';
      }
      function onScroll() {
        if (!visible || finePointer) return;
        if (!paraRaf) paraRaf = requestAnimationFrame(applyParallax);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (finePointer && floatEl) {
        floatEl.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = tiltEl.getBoundingClientRect();
          var px = (e.clientX - r.left) / Math.max(r.width, 1) - 0.5;
          var py = (e.clientY - r.top) / Math.max(r.height, 1) - 0.5;
          var rx = -py * 12, ry = px * 12;
          if (rx > 6) rx = 6; else if (rx < -6) rx = -6;
          if (ry > 6) ry = 6; else if (ry < -6) ry = -6;
          tiltEl.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
          if (shineEl) {
            shineEl.style.opacity = '1';
            shineEl.style.transform = 'translate3d(' + (e.clientX - r.left - 120) + 'px,' + (e.clientY - r.top - 120) + 'px,0)';
          }
        });
        floatEl.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          tiltEl.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
          if (shineEl) shineEl.style.opacity = '0';
        });
      }
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-home-history]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-home-kontakt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vhkInit) return;
    root.dataset.vhkInit = '1';

    root.querySelectorAll('[data-vhk-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-vhk-copy');
        var done = function () { btn.textContent = 'Skopiowano ✓'; btn.classList.add('is-done');
          setTimeout(function () { btn.textContent = 'Kopiuj'; btn.classList.remove('is-done'); }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(val).then(done, function () {});
        else { var t = document.createElement('textarea'); t.value = val; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} t.remove(); }
      });
    });

    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.15 });
    io.observe(root);
    setTimeout(function () { root.classList.add('is-in'); }, 4000);
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-viva-home-kontakt]').forEach(init); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-kadra"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initKadra(root) {
    if (!root || root.dataset.vkInit) return;
    root.dataset.vkInit = 'true';

    var drawer = root.querySelector('[data-vk-drawer]');
    if (!drawer) return;

    // Portal: move drawer to <body> so no ancestor transform breaks fixed/scroll.
    var wrapper = root.closest('.shopify-section') || root;
    var pid = wrapper.id || ('vk-' + Math.random().toString(36).slice(2));
    var stale = document.querySelector('body > [data-vk-portal="' + pid + '"]');
    if (stale) stale.remove();
    drawer.setAttribute('data-vk-portal', pid);
    document.body.appendChild(drawer);

    var overlay = drawer.querySelector('.vk-drawer__overlay');
    var panel   = drawer.querySelector('.vk-panel');
    var content = drawer.querySelector('[data-vk-content]');
    var countEl = drawer.querySelector('[data-vk-count]');
    var details = drawer.querySelectorAll('[data-vk-detail]');
    var openers = root.querySelectorAll('[data-vk-open]');
    var closers = drawer.querySelectorAll('[data-vk-close]');

    var total = details.length;
    var G = window.gsap;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isOpen = false;
    function getLenis() {
      return window.lenis || window.vivaLenis || (window.vivaMotion && window.vivaMotion.lenis);
    }

    // Lock background scroll on <html> only (NOT position:fixed / overflow on body or panel).
    function lock()   { document.documentElement.style.overflow = 'hidden'; }
    function unlock() { document.documentElement.style.overflow = ''; }

    function showDetail(i) {
      details.forEach(function (d) { d.hidden = true; d.style.display = 'none'; });
      var el = drawer.querySelector('[data-vk-detail="' + i + '"]');
      if (el) { el.hidden = false; el.style.display = 'block'; }
      if (countEl) countEl.textContent = (parseInt(i, 10) + 1) + ' / ' + total;
      if (content) content.scrollTop = 0;
    }

    function open(i) {
      var ln = getLenis();
      if (ln && ln.stop) ln.stop();
      showDetail(i);
      drawer.setAttribute('aria-hidden', 'false');
      isOpen = true;
      lock();
      if (G && !reduce) {
        G.killTweensOf([overlay, panel]);
        G.to(overlay, { opacity: 0.5, duration: 0.5, ease: 'power2.inOut' });
        G.to(panel,   { x: 0, duration: 0.65, ease: 'power3.inOut' });
      } else {
        requestAnimationFrame(function () {
          overlay.style.opacity = '0.5';
          panel.style.transform = 'translateX(0)';
        });
      }
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      unlock();
      var ln = getLenis();
      if (ln && ln.start) ln.start();
      if (G && !reduce) {
        G.killTweensOf([overlay, panel]);
        G.to(panel,   { x: '100%', duration: 0.6, ease: 'power3.inOut', delay: 0.1 });
        G.to(overlay, { opacity: 0, duration: 0.5, ease: 'power2.inOut', delay: 0.1,
          onComplete: function () { drawer.setAttribute('aria-hidden', 'true'); } });
      } else {
        panel.style.transform = 'translateX(100%)';
        overlay.style.opacity = '0';
        drawer.setAttribute('aria-hidden', 'true');
      }
    }

    // Lenis / document wheel must not steal the panel. No preventDefault inside the panel.
    panel.addEventListener('wheel', function (e) { e.stopPropagation(); }, { passive: true });
    panel.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });

    openers.forEach(function (btn) { btn.addEventListener('click', function () { open(btn.getAttribute('data-vk-open')); }); });
    closers.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-viva-kadra]').forEach(initKadra); }

  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-kontakt-zapisy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initKZ(root) {
    if (!root || root.dataset.vkzInit) return;
    root.dataset.vkzInit = 'true';
    var tabsWrap = root.querySelector('.vkz__tabs');
    var tabs = root.querySelectorAll('[data-vkz-tab]');
    var panels = root.querySelectorAll('[data-vkz-panel]');
    function activate(name) {
      tabs.forEach(function (t) { var on = t.getAttribute('data-vkz-tab') === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-vkz-panel') === name); });
      if (tabsWrap) tabsWrap.setAttribute('data-active', name);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-vkz-tab')); }); });
    // Після відправки формуляра або лінк #zapisy — показати вкладку Zapisy
    if (window.location.hash === '#zapisy' || root.querySelector('[data-vkz-thanks]')) activate('zapisy');
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-viva-kz]').forEach(initKZ); }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
